import { Section } from 'custom-form-lib';

const START_DEV_SEC_OPS_SECTION = {
    contentId: 'Start',
    onInvalidMessage: 'Starten',
    onValidMessage: 'Starten',
    formGroupType: 'NoControl',
} as Section;

const INTRODUCTION_SECTION = {
    contentId: 'Introduction',
    formGroupType: 'TextInputControl',
    options: ['Dein Vorname', 'Dein Nachname'],
    formControlNames: ['firstName', 'lastName'],
    required: true,
    title: `
    <p class="text-[22px] font-bold font-figtree
      900:text-[28px]">
      <span class="text-orange">
        Schön, dass Du hier bist.
      </span> Bitte stelle dich kurz vor.
    </p>`,
} as Section;

const AGE_SECTION = {
    formGroupType: 'SingleChoiceControl',
    options: ['18-25', '26-35', '36-45', '46+'],
    formControlNames: ['age'],
    required: true,
    title: 'Wie alt bist du?',
} as Section;

const PROFESSION_SECTION = {
    formGroupType: 'SingleChoiceControl',
    options: [
        'Angestellt',
        'Selbstständig',
        // "Schüler / Schülerin",
        'Student / Studentin',
        // "Arbeitssuchend",
        'Bald Arbeitslos', // new
        'Arbeitslos (nicht beim Jobcenter/Agentur für Arbeit gemeldet)', // new
        'Arbeitslos (beim Jobcenter/Agentur für Arbeit gemeldet)', // new
        // "Sonstiges"
    ],
    formControlNames: ['profession'],
    required: true,
    title: 'Dein aktueller Berufsstand',
} as Section;

const EXPERIENCE_SECTION = {
    formGroupType: 'SingleChoiceControl',
    formControlNames: ['experience'],
    options: [
        'Ich habe keine Programmiererfahrung.',
        'Ich habe Grundkenntnisse in mindestens einer Programmiersprache.',
        'Ich programmiere regelmäßig, besonders in Python.',
        'Ich bin erfahrener Entwickler mit Kenntnissen in mehreren Sprachen.',
    ],
    title: 'Welche Programmiererfahrung bringst du mit?',
    required: true,
} as Section;

const DESIRES_SECTION = {
    formGroupType: 'MultipleChoiceControl',
    formControlNames: ['desires'],
    options: [
        'Die Integration von Sicherheit in den Entwicklungsprozess.',
        'Die Automatisierung von Entwicklungs- und Bereitstellungsprozessen.',
        'Die Arbeit mit Cloud-Technologien und Containern.',
        'Die Optimierung der Zusammenarbeit zwischen Entwicklung und IT-Betrieb.',
    ],
    title: 'Was interessiert dich am meisten an DevSecOps?',
    required: true,
} as Section;

const DEV_SEC_OPS_EXPERIENCE_SECTION = {
    formGroupType: 'MultipleChoiceControl',
    formControlNames: ['devSecOpsExperience'],
    options: [
        'Ich habe noch keine Erfahrung mit DevOps oder DevSecOps.',
        'Ich habe bereits Erfahrung mit DevOps Tools wie Github Actions, Jenkins CI, GitLab CI.',
        'Ich verfüge über Erfahrung mit CI/CD und Container-Technologien.',
        'Ich habe bereits mit Cloudtechnologien gearbeitet.',
    ],
    title: 'Welche der folgenden Aussagen beschreiben deine Erfahrungen  im Bereich DevSecOps?',
    required: true,
} as Section;

const WILL_SECTION = {
    onInvalidMessage: 'Bitte ausfüllen',
    formGroupType: 'TextAreaInputControl',
    formControlNames: ['will'],
    options: ['Gib hier deine Antwort ein...'],
    required: true,
    title: 'Was motiviert dich an einer Weiterbildung in DevSecOps?',
    maxLength: [254],
} as Section;

const EMAIL_SECTION = {
    contentId: 'EmailAddress',
    onInvalidMessage: 'Bitte ausfüllen',
    formGroupType: 'EmailInputControl',
    formControlNames: ['email'],
    options: ['Deine E-Mail Adresse'],
    title: 'Deine E-Mail für die Terminbestätigung',
    required: true,
} as Section;

const PHONE_NUMBER_SECTION = {
    formGroupType: 'PhoneInputControl',
    formControlNames: ['phoneNumber'],
    options: ['012345678901'],
    preselectedValues: ['+49'],
    title: 'Unter welcher Telefonnummer können wir Dich für das Beratungsgespräch erreichen?',
    required: true,
} as Section;

const REACHABLE_SECTION = {
    formGroupType: 'SingleChoiceControl',
    formControlNames: ['reachable'],
    options: ['Morgens, zwischen 8-12 Uhr', 'Nachmittags, zwischen 13-17 Uhr', 'Abends, zwischen 17-20 Uhr'],
    title: 'Wann bist Du in der Regel am besten (telefonisch) erreichbar?',
    required: true,
} as Section;

const LEAD_SOURCE_SECTION = {
    formGroupType: 'MultipleChoiceControl',
    formControlNames: ['leadSource'],
    options: ['Suchmaschine (z.B. Google, Bing)', 'Youtube', 'Instagram', 'Facebook', 'TikTok', 'mein NOW', 'Podcast'],
    title: 'Wie bist du auf uns aufmerksam geworden?',
    required: true,
    optionalInput: 'Sonstiges',
    onValidMessage: 'Übermitteln',
} as Section;

export const DEVSECOPS_SECTIONS = [
    START_DEV_SEC_OPS_SECTION,
    INTRODUCTION_SECTION,
    AGE_SECTION,
    PROFESSION_SECTION,
    EXPERIENCE_SECTION,
    DESIRES_SECTION,
    DEV_SEC_OPS_EXPERIENCE_SECTION,
    WILL_SECTION,
    EMAIL_SECTION,
    PHONE_NUMBER_SECTION,
    REACHABLE_SECTION,
    LEAD_SOURCE_SECTION,
];
